import * as Types from '../../models.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBooksQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  filter?: Types.InputMaybe<Types.BooksFilterArgDto>;
  sort?: Types.InputMaybe<Types.BooksSortArgDto>;
}>;


export type GetBooksQuery = { books: Array<{ id: string, name?: string | null, createdAt: any, updatedAt: any, author?: string | null, narrativeLead?: string | null, fantasy: boolean, status: string, app?: Array<string> | null, localized?: Array<string> | null, extra: Array<string>, outline?: string | null, customId?: string | null, artDocument?: string | null, charactersBible?: string | null, genres: Array<string>, fantasyCategories: Array<string>, fresh: boolean, redesigned: boolean, has_new_customization: boolean, trending: boolean, series?: Array<string> | null, category?: string | null, imagePreviewGP?: string | null, imagePreviewIOS?: string | null, imageMenuIOS?: string | null, imageMenuGP?: string | null, finished: boolean }> };

export type GetBookQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetBookQuery = { book: { id: string, customId?: string | null, name?: string | null, stage: string, category?: string | null, menuImage?: string | null, imageMenuIOS?: string | null, imageMenuGP?: string | null, imagePreviewGP?: string | null, imagePreviewIOS?: string | null, imageMenuSpainIOS?: string | null, imageMenuSpainGP?: string | null, imageMenuGermanIOS?: string | null, imageMenuGermanGP?: string | null, imageMenuFrenchIOS?: string | null, imageMenuFrenchGP?: string | null, imagePreviewSpainIOS?: string | null, imagePreviewSpainGP?: string | null, imagePreviewGermanIOS?: string | null, imagePreviewGermanGP?: string | null, imagePreviewFrenchIOS?: string | null, imagePreviewFrenchGP?: string | null, imageMenuDutchIOS?: string | null, imagePreviewDutchIOS?: string | null, imageMenuDutchGP?: string | null, imagePreviewDutchGP?: string | null, imageMenuPortugueseIOS?: string | null, imagePreviewPortugueseIOS?: string | null, imageMenuPortugueseGP?: string | null, imagePreviewPortugueseGP?: string | null, imageMenuItalianIOS?: string | null, imagePreviewItalianIOS?: string | null, imageMenuItalianGP?: string | null, imagePreviewItalianGP?: string | null, imageMenuPolishIOS?: string | null, imagePreviewPolishIOS?: string | null, imageMenuPolishGP?: string | null, imagePreviewPolishGP?: string | null, imageMenuSwedishIOS?: string | null, imagePreviewSwedishIOS?: string | null, imageMenuSwedishGP?: string | null, imagePreviewSwedishGP?: string | null, imageMenuDanishIOS?: string | null, imagePreviewDanishIOS?: string | null, imageMenuDanishGP?: string | null, imagePreviewDanishGP?: string | null, imageMenuNorwegianIOS?: string | null, imagePreviewNorwegianIOS?: string | null, imageMenuNorwegianGP?: string | null, imagePreviewNorwegianGP?: string | null, imageMenuFinnishIOS?: string | null, imagePreviewFinnishIOS?: string | null, imageMenuFinnishGP?: string | null, imagePreviewFinnishGP?: string | null, imageMenuIndonesianIOS?: string | null, imagePreviewIndonesianIOS?: string | null, imageMenuIndonesianGP?: string | null, imagePreviewIndonesianGP?: string | null, imageMenuCzechIOS?: string | null, imagePreviewCzechIOS?: string | null, imageMenuCzechGP?: string | null, imagePreviewCzechGP?: string | null, imageMenuRomanianIOS?: string | null, imagePreviewRomanianIOS?: string | null, imageMenuRomanianGP?: string | null, imagePreviewRomanianGP?: string | null, imageMenuHungarianIOS?: string | null, imagePreviewHungarianIOS?: string | null, imageMenuHungarianGP?: string | null, imagePreviewHungarianGP?: string | null, imageMenuTurkishIOS?: string | null, imagePreviewTurkishIOS?: string | null, imageMenuTurkishGP?: string | null, imagePreviewTurkishGP?: string | null, imageMenuJapaneseIOS?: string | null, imagePreviewJapaneseIOS?: string | null, imageMenuJapaneseGP?: string | null, imagePreviewJapaneseGP?: string | null, imageMenuKoreanIOS?: string | null, imagePreviewKoreanIOS?: string | null, imageMenuKoreanGP?: string | null, imagePreviewKoreanGP?: string | null, imageMenuBrazilianIOS?: string | null, imagePreviewBrazilianIOS?: string | null, imageMenuBrazilianGP?: string | null, imagePreviewBrazilianGP?: string | null, fantasy: boolean, localized?: Array<string> | null, nameES?: string | null, nameDE?: string | null, nameFR?: string | null, namePT?: string | null, nameNL?: string | null, nameIT?: string | null, namePL?: string | null, nameSV?: string | null, nameDA?: string | null, nameNO?: string | null, nameFI?: string | null, nameID?: string | null, nameCS?: string | null, nameRO?: string | null, nameHU?: string | null, nameTR?: string | null, nameJA?: string | null, nameKO?: string | null, namePT_BR?: string | null, genres: Array<string>, logline?: string | null, synopsis?: string | null, author?: string | null, narrativeLead?: string | null, extra: Array<string>, series?: Array<string> | null, outline?: string | null, artDocument?: string | null, charactersBible?: string | null, fresh: boolean, redesigned: boolean, has_new_customization: boolean, trending: boolean, status: string, app?: Array<string> | null, fantasyCategories: Array<string>, finished: boolean, createdAt: any, updatedAt: any, bookNotes?: string | null, chapters?: Array<{ id: string, name?: string | null, nameDE?: string | null, nameES?: string | null, nameFR?: string | null, namePT?: string | null, nameNL?: string | null, nameIT?: string | null, namePL?: string | null, nameSV?: string | null, nameDA?: string | null, nameNO?: string | null, nameFI?: string | null, nameID?: string | null, nameCS?: string | null, nameRO?: string | null, nameHU?: string | null, nameTR?: string | null, nameJA?: string | null, nameKO?: string | null, namePT_BR?: string | null, descriptionDE?: string | null, descriptionFR?: string | null, descriptionES?: string | null, descriptionPT?: string | null, descriptionNL?: string | null, descriptionIT?: string | null, descriptionPL?: string | null, descriptionSV?: string | null, descriptionDA?: string | null, descriptionNO?: string | null, descriptionFI?: string | null, descriptionID?: string | null, descriptionCS?: string | null, descriptionRO?: string | null, descriptionHU?: string | null, descriptionTR?: string | null, descriptionJA?: string | null, descriptionKO?: string | null, descriptionPT_BR?: string | null, updatedAt: any, description?: string | null, luaLink?: string | null, hasTwoPovs?: boolean | null, isVideo?: boolean | null, secondHeroName?: string | null, secondPovLua?: string | null, secondPovLuaFR?: string | null, secondPovLuaES?: string | null, secondPovLuaNL?: string | null, secondPovLuaPT?: string | null, secondPovLuaIT?: string | null, secondPovLuaPL?: string | null, secondPovLuaSV?: string | null, secondPovLuaDA?: string | null, secondPovLuaNO?: string | null, secondPovLuaFI?: string | null, secondPovLuaID?: string | null, secondPovLuaCS?: string | null, secondPovLuaRO?: string | null, secondPovLuaHU?: string | null, secondPovLuaTR?: string | null, secondPovLuaJA?: string | null, secondPovLuaKO?: string | null, secondPovLuaPT_BR?: string | null, chapterOrder?: number | null, status?: string | null, managementStatus: Array<Types.Chapter_Status>, author?: string | null, additionalDocs?: Array<{ id: string, docOrder?: number | null, docNotes?: { id: string, name?: string | null, link?: string | null, description?: string | null, isActive?: boolean | null } | null }> | null, googleDoc?: { id: string, link?: string | null } | null, googleDoc2Pov?: { id: string, link?: string | null } | null, googleDoc2PovFR?: { id: string, link?: string | null } | null, googleDoc2PovDE?: { id: string, link?: string | null } | null, googleDoc2PovES?: { id: string, link?: string | null } | null, googleDoc2PovNL?: { id: string, link?: string | null } | null, googleDoc2PovPT?: { id: string, link?: string | null } | null, googleDoc2PovIT?: { id: string, link?: string | null } | null, googleDoc2PovPL?: { id: string, link?: string | null } | null, googleDoc2PovSV?: { id: string, link?: string | null } | null, googleDoc2PovDA?: { id: string, link?: string | null } | null, googleDoc2PovNO?: { id: string, link?: string | null } | null, googleDoc2PovFI?: { id: string, link?: string | null } | null, googleDoc2PovID?: { id: string, link?: string | null } | null, googleDoc2PovCS?: { id: string, link?: string | null } | null, googleDoc2PovRO?: { id: string, link?: string | null } | null, googleDoc2PovHU?: { id: string, link?: string | null } | null, googleDoc2PovTR?: { id: string, link?: string | null } | null, googleDoc2PovJA?: { id: string, link?: string | null } | null, googleDoc2PovKO?: { id: string, link?: string | null } | null, googleDoc2PovPT_BR?: { id: string, link?: string | null } | null, googleDocABTest1?: { id: string, link?: string | null, docNotes?: { id: string, name?: string | null, link?: string | null, description?: string | null, isActive?: boolean | null } | null } | null, googleDocABTest2?: { id: string, link?: string | null, docNotes?: { id: string, name?: string | null, link?: string | null, description?: string | null, isActive?: boolean | null } | null } | null, googleDocABTest3?: { id: string, link?: string | null, docNotes?: { id: string, name?: string | null, link?: string | null, description?: string | null, isActive?: boolean | null } | null } | null, googleDocWriter?: { id: string, link?: string | null } | null, googleDocNarrative?: { id: string, link?: string | null } | null, googleDocES?: { id: string, link?: string | null } | null, googleDocFR?: { id: string, link?: string | null } | null, googleDocDE?: { id: string, link?: string | null } | null, googleDocNL?: { id: string, link?: string | null } | null, googleDocPT?: { id: string, link?: string | null } | null, googleDocIT?: { id: string, link?: string | null } | null, googleDocPL?: { id: string, link?: string | null } | null, googleDocSV?: { id: string, link?: string | null } | null, googleDocDA?: { id: string, link?: string | null } | null, googleDocNO?: { id: string, link?: string | null } | null, googleDocFI?: { id: string, link?: string | null } | null, googleDocID?: { id: string, link?: string | null } | null, googleDocCS?: { id: string, link?: string | null } | null, googleDocRO?: { id: string, link?: string | null } | null, googleDocHU?: { id: string, link?: string | null } | null, googleDocTR?: { id: string, link?: string | null } | null, googleDocJA?: { id: string, link?: string | null } | null, googleDocKO?: { id: string, link?: string | null } | null, googleDocPT_BR?: { id: string, link?: string | null } | null }> | null } };

export type GetBookInfoQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetBookInfoQuery = { bookInfo: { chaptersCount: number, heroesCount: number, backgroundsCount: number, itemsCount: number, cardsCount: number } };

export type GetBookCustomIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetBookCustomIdQuery = { book: { customId?: string | null } };


export const GetBooksDocument = gql`
    query GetBooks($page: Int, $limit: Int, $filter: BooksFilterArgDto, $sort: BooksSortArgDto) {
  books(page: $page, limit: $limit, filter: $filter, sort: $sort) {
    id
    name
    createdAt
    updatedAt
    author
    narrativeLead
    fantasy
    status
    app
    localized
    extra
    outline
    customId
    artDocument
    charactersBible
    genres
    fantasyCategories
    fresh
    redesigned
    has_new_customization
    trending
    series
    category
    imagePreviewGP
    imagePreviewIOS
    imageMenuIOS
    imageMenuGP
    finished
  }
}
    `;

/**
 * __useGetBooksQuery__
 *
 * To run a query within a React component, call `useGetBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBooksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetBooksQuery(baseOptions?: Apollo.QueryHookOptions<GetBooksQuery, GetBooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBooksQuery, GetBooksQueryVariables>(GetBooksDocument, options);
      }
export function useGetBooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBooksQuery, GetBooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBooksQuery, GetBooksQueryVariables>(GetBooksDocument, options);
        }
export type GetBooksQueryHookResult = ReturnType<typeof useGetBooksQuery>;
export type GetBooksLazyQueryHookResult = ReturnType<typeof useGetBooksLazyQuery>;
export type GetBooksQueryResult = Apollo.QueryResult<GetBooksQuery, GetBooksQueryVariables>;
export const GetBookDocument = gql`
    query GetBook($id: String!) {
  book(id: $id) {
    id
    customId
    name
    stage
    category
    menuImage
    imageMenuIOS
    imageMenuGP
    imagePreviewGP
    imagePreviewIOS
    imageMenuSpainIOS
    imageMenuSpainGP
    imageMenuGermanIOS
    imageMenuGermanGP
    imageMenuFrenchIOS
    imageMenuFrenchGP
    imagePreviewSpainIOS
    imagePreviewSpainGP
    imagePreviewGermanIOS
    imagePreviewGermanGP
    imagePreviewFrenchIOS
    imagePreviewFrenchGP
    imageMenuDutchIOS
    imagePreviewDutchIOS
    imageMenuDutchGP
    imagePreviewDutchGP
    imageMenuPortugueseIOS
    imagePreviewPortugueseIOS
    imageMenuPortugueseGP
    imagePreviewPortugueseGP
    imageMenuItalianIOS
    imagePreviewItalianIOS
    imageMenuItalianGP
    imagePreviewItalianGP
    imageMenuPolishIOS
    imagePreviewPolishIOS
    imageMenuPolishGP
    imagePreviewPolishGP
    imageMenuSwedishIOS
    imagePreviewSwedishIOS
    imageMenuSwedishGP
    imagePreviewSwedishGP
    imageMenuDanishIOS
    imagePreviewDanishIOS
    imageMenuDanishGP
    imagePreviewDanishGP
    imageMenuNorwegianIOS
    imagePreviewNorwegianIOS
    imageMenuNorwegianGP
    imagePreviewNorwegianGP
    imageMenuFinnishIOS
    imagePreviewFinnishIOS
    imageMenuFinnishGP
    imagePreviewFinnishGP
    imageMenuIndonesianIOS
    imagePreviewIndonesianIOS
    imageMenuIndonesianGP
    imagePreviewIndonesianGP
    imageMenuCzechIOS
    imagePreviewCzechIOS
    imageMenuCzechGP
    imagePreviewCzechGP
    imageMenuRomanianIOS
    imagePreviewRomanianIOS
    imageMenuRomanianGP
    imagePreviewRomanianGP
    imageMenuHungarianIOS
    imagePreviewHungarianIOS
    imageMenuHungarianGP
    imagePreviewHungarianGP
    imageMenuTurkishIOS
    imagePreviewTurkishIOS
    imageMenuTurkishGP
    imagePreviewTurkishGP
    imageMenuJapaneseIOS
    imagePreviewJapaneseIOS
    imageMenuJapaneseGP
    imagePreviewJapaneseGP
    imageMenuKoreanIOS
    imagePreviewKoreanIOS
    imageMenuKoreanGP
    imagePreviewKoreanGP
    imageMenuBrazilianIOS
    imagePreviewBrazilianIOS
    imageMenuBrazilianGP
    imagePreviewBrazilianGP
    customId
    fantasy
    localized
    nameES
    nameDE
    nameFR
    namePT
    nameNL
    nameIT
    namePL
    nameSV
    nameDA
    nameNO
    nameFI
    nameID
    nameCS
    nameRO
    nameHU
    nameTR
    nameJA
    nameKO
    namePT_BR
    genres
    logline
    synopsis
    author
    narrativeLead
    extra
    series
    outline
    artDocument
    charactersBible
    fresh
    redesigned
    has_new_customization
    trending
    status
    app
    fantasyCategories
    finished
    createdAt
    updatedAt
    bookNotes
    chapters {
      id
      name
      nameDE
      nameES
      nameFR
      namePT
      nameNL
      nameIT
      namePL
      nameSV
      nameDA
      nameNO
      nameFI
      nameID
      nameCS
      nameRO
      nameHU
      nameTR
      nameJA
      nameKO
      namePT_BR
      descriptionDE
      descriptionFR
      descriptionES
      descriptionPT
      descriptionNL
      descriptionIT
      descriptionPL
      descriptionSV
      descriptionDA
      descriptionNO
      descriptionFI
      descriptionID
      descriptionCS
      descriptionRO
      descriptionHU
      descriptionTR
      descriptionJA
      descriptionKO
      descriptionPT_BR
      updatedAt
      description
      luaLink
      hasTwoPovs
      isVideo
      secondHeroName
      secondPovLua
      secondPovLuaFR
      secondPovLuaES
      secondPovLuaNL
      secondPovLuaPT
      secondPovLuaIT
      secondPovLuaPL
      secondPovLuaSV
      secondPovLuaDA
      secondPovLuaNO
      secondPovLuaFI
      secondPovLuaID
      secondPovLuaCS
      secondPovLuaRO
      secondPovLuaHU
      secondPovLuaTR
      secondPovLuaJA
      secondPovLuaKO
      secondPovLuaPT_BR
      additionalDocs {
        id
      }
      googleDoc {
        id
        link
      }
      googleDoc2Pov {
        id
        link
      }
      googleDoc2PovFR {
        id
        link
      }
      googleDoc2PovDE {
        id
        link
      }
      googleDoc2PovES {
        id
        link
      }
      googleDoc2PovNL {
        id
        link
      }
      googleDoc2PovPT {
        id
        link
      }
      googleDoc2PovIT {
        id
        link
      }
      googleDoc2PovPL {
        id
        link
      }
      googleDoc2PovSV {
        id
        link
      }
      googleDoc2PovDA {
        id
        link
      }
      googleDoc2PovNO {
        id
        link
      }
      googleDoc2PovFI {
        id
        link
      }
      googleDoc2PovID {
        id
        link
      }
      googleDoc2PovCS {
        id
        link
      }
      googleDoc2PovRO {
        id
        link
      }
      googleDoc2PovHU {
        id
        link
      }
      googleDoc2PovTR {
        id
        link
      }
      googleDoc2PovJA {
        id
        link
      }
      googleDoc2PovKO {
        id
        link
      }
      googleDoc2PovPT_BR {
        id
        link
      }
      googleDocABTest1 {
        id
        link
        docNotes {
          id
          name
          link
          description
          isActive
        }
      }
      googleDocABTest2 {
        id
        link
        docNotes {
          id
          name
          link
          description
          isActive
        }
      }
      googleDocABTest3 {
        id
        link
        docNotes {
          id
          name
          link
          description
          isActive
        }
      }
      googleDocWriter {
        id
        link
      }
      googleDocNarrative {
        id
        link
      }
      googleDocES {
        id
        link
      }
      googleDocFR {
        id
        link
      }
      googleDocDE {
        id
        link
      }
      googleDocNL {
        id
        link
      }
      googleDocPT {
        id
        link
      }
      googleDocIT {
        id
        link
      }
      googleDocPL {
        id
        link
      }
      googleDocSV {
        id
        link
      }
      googleDocDA {
        id
        link
      }
      googleDocNO {
        id
        link
      }
      googleDocFI {
        id
        link
      }
      googleDocID {
        id
        link
      }
      googleDocCS {
        id
        link
      }
      googleDocRO {
        id
        link
      }
      googleDocHU {
        id
        link
      }
      googleDocTR {
        id
        link
      }
      googleDocJA {
        id
        link
      }
      googleDocKO {
        id
        link
      }
      googleDocPT_BR {
        id
        link
      }
      additionalDocs {
        id
        docOrder
        docNotes {
          id
          name
          link
          description
          isActive
        }
      }
      chapterOrder
      status
      hasTwoPovs
      managementStatus
      author
    }
  }
}
    `;

/**
 * __useGetBookQuery__
 *
 * To run a query within a React component, call `useGetBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookQuery(baseOptions: Apollo.QueryHookOptions<GetBookQuery, GetBookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookQuery, GetBookQueryVariables>(GetBookDocument, options);
      }
export function useGetBookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookQuery, GetBookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookQuery, GetBookQueryVariables>(GetBookDocument, options);
        }
export type GetBookQueryHookResult = ReturnType<typeof useGetBookQuery>;
export type GetBookLazyQueryHookResult = ReturnType<typeof useGetBookLazyQuery>;
export type GetBookQueryResult = Apollo.QueryResult<GetBookQuery, GetBookQueryVariables>;
export const GetBookInfoDocument = gql`
    query GetBookInfo($id: String!) {
  bookInfo(id: $id) {
    chaptersCount
    heroesCount
    backgroundsCount
    itemsCount
    cardsCount
  }
}
    `;

/**
 * __useGetBookInfoQuery__
 *
 * To run a query within a React component, call `useGetBookInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookInfoQuery(baseOptions: Apollo.QueryHookOptions<GetBookInfoQuery, GetBookInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookInfoQuery, GetBookInfoQueryVariables>(GetBookInfoDocument, options);
      }
export function useGetBookInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookInfoQuery, GetBookInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookInfoQuery, GetBookInfoQueryVariables>(GetBookInfoDocument, options);
        }
export type GetBookInfoQueryHookResult = ReturnType<typeof useGetBookInfoQuery>;
export type GetBookInfoLazyQueryHookResult = ReturnType<typeof useGetBookInfoLazyQuery>;
export type GetBookInfoQueryResult = Apollo.QueryResult<GetBookInfoQuery, GetBookInfoQueryVariables>;
export const GetBookCustomIdDocument = gql`
    query GetBookCustomId($id: String!) {
  book(id: $id) {
    customId
  }
}
    `;

/**
 * __useGetBookCustomIdQuery__
 *
 * To run a query within a React component, call `useGetBookCustomIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookCustomIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookCustomIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookCustomIdQuery(baseOptions: Apollo.QueryHookOptions<GetBookCustomIdQuery, GetBookCustomIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookCustomIdQuery, GetBookCustomIdQueryVariables>(GetBookCustomIdDocument, options);
      }
export function useGetBookCustomIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookCustomIdQuery, GetBookCustomIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookCustomIdQuery, GetBookCustomIdQueryVariables>(GetBookCustomIdDocument, options);
        }
export type GetBookCustomIdQueryHookResult = ReturnType<typeof useGetBookCustomIdQuery>;
export type GetBookCustomIdLazyQueryHookResult = ReturnType<typeof useGetBookCustomIdLazyQuery>;
export type GetBookCustomIdQueryResult = Apollo.QueryResult<GetBookCustomIdQuery, GetBookCustomIdQueryVariables>;